import { useTranslation } from 'react-i18next';

import { useDashboardDaysStore } from '@Models/useDashboardDaysModel';
import DashboardLayout from '@Dashboard/Layout/DashboardLayout';
import TimeRangeSelector from '@Dashboard/TimeRangeSelector';
import SummaryAtpRisk from './SummaryAtpRisk';
import SummaryDlpRisk from './SummaryDlpRisk';
import SummaryScanned from './SummaryScanned';
import { DashboardPeriod } from '@Types/dashboard';
import { useExpandSection } from '../useExpandSection';

export default function Summary() {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'summary',
      period: daysModel.days.DashboardSummary as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.summary')}
      titleBar={<TimeRangeSelector widgetId="DashboardSummary" />}
      barColor="#A3BF60"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <SummaryScanned data={data} day={daysModel.days['DashboardSummary']} />
      <SummaryAtpRisk data={data} day={daysModel.days['DashboardSummary']} />
      <SummaryDlpRisk data={data} day={daysModel.days['DashboardSummary']} />
    </DashboardLayout>
  );
}
